import { WorldMapListJson } from "@/types/worldmap";


const BBE_BASE = process.env.REACT_APP_BEETLE_BE_URL || "";
const API_WORLD_MAP = "/api/deepscan/worldmap";


export async function getSmallModelUrl(sessionId: string) {
  const worldMapApi = new URL(API_WORLD_MAP, BBE_BASE);

  const apiKey = process.env.REACT_APP_BEETLE_API_KEY || "";
  const url = new URL(sessionId, `${worldMapApi}/`);

  const res = await fetch(url.toString(), {
    method: "GET",
    headers: { "x-api-key": apiKey },
  });

  if (!res.ok) throw new Error(`Failed: ${res.status}`);
  const result = await res.json();
  return result.data;
}

export async function findWorldMapModel(
  userId: string,
  coords: string,
  zoom: string
) {
  const url = new URL(API_WORLD_MAP, BBE_BASE);
  url.search = new URLSearchParams({
    userId,
    coords,
    zoom,
  }).toString();

  const apiKey = process.env.REACT_APP_BEETLE_API_KEY || "";
  const res = await fetch(url.toString(), {
    method: "GET",
    headers: { "x-api-key": apiKey },
  });

  if (!res.ok) throw new Error(`Failed: ${res.status}`);
  return (await res.json()) as WorldMapListJson;

}